import React from 'react'
import { connect } from 'react-redux'
import withApp from '@brainstud/react-tbl/core/provider/withApp'
// TODO get appRoutes from provider
import { appRoutes } from '@brainstud/react-tbl/features'
import { routeTo } from '@brainstud/react-helpers'
// TODO move ui
// import { LayoutFooter, Button, ButtonsGroup, Overview } from '@brainstud/schiphol-vtc-ui'

const Footer = props => (
  <LayoutFooter style={props.theme}>
    <div>
      <ButtonsGroup>
        {props.homeButton &&
          <Button to={routeTo(appRoutes, 'home')} link outline round inversed icon="home" label={false} iconSize="small" />
        }
        {props.mapButton &&
          <Button outline round inversed icon="map" label={false} iconSize="small"
            onClick={() => props.app.toggleGlobalMap(props.mapButtonLayers)}
            highlight={!props.app.globalMap && props.mapButtonLayers.length > 0} />
        }
      </ButtonsGroup>
    </div>
    <div>
      {props.title &&
        <Overview
          title={props.title}
          items={props.items}
          active={props.active} />
      }
    </div>
    <div>
      <ButtonsGroup align="right">
        {props.prevButton &&
          <Button
            onClick={props.prevClick}
            to={props.prevTo}
            link={props.prevTo}
            disabled={props.prevDisabled}
            inversed
            icon="arrow-left"
            label={props.prevLabel}
            iconSize="small" />
        }
        {props.nextButton &&
          <Button
            bold
            onClick={props.nextClick}
            to={props.nextTo}
            link={props.nextTo}
            disabled={props.nextDisabled}
            inversed
            icon="arrow-right"
            iconPosition="right"
            label={props.nextLabel}
            iconSize="small" />
        }
      </ButtonsGroup>
    </div>
  </LayoutFooter>
)

export default withApp(connect(
  (state, props) => {
    const theme = props.app.themes[props.app.currentTheme]

    return { theme }
  },
  () => ({}),
)(Footer))
